import React, { ReactElement } from 'react';
import TemplatePage, { TemplatePageProps } from "../template_page/template_page";
import axios from "axios";
import { Page } from "../../model/page";
import { API_CONFIG, LAST_COMPONENT_ID } from "../../config/api_config";
import { HIGH_LEVEL_CONFIG } from "../../config/high_level_config";
import { COMPONENTS } from "../../config/components";
import { HOME_PAGE_FOOTER_LINKS, SUBPAGE_FOOTER_ADDITIONAL_LINKS } from "../../config/footer_contents";

import { computeBackendPath } from "../../containers/page_dispatcher/page_dispatcher";
import ErrorBoundary from "../../common_components/error_boundary/error_boundary";
import C100ProfileCard from "../../luiss_components/c100_profile_card/c100_profile_card";
import { ComponentId } from "../../model/component_id";
import { extraSmallLayout } from "../../utils/device";
import { Col, Container, Row } from "react-bootstrap";
import NotFoundComponent from "../template_page/not_found/not_found";
import Helmet from "react-helmet";
import TemplateCoursePagePlaceholder from "../template_page/template_course_page/template_course_page";
import TemplatePageFooter from "../template_page/template_page_footer/template_page_footer";
import TemplatePagePlaceholder from "../template_page/template_page_placeholder/template_page_placeholder";

class FacultyProfilePage extends TemplatePage {

    constructor(props: TemplatePageProps) {
        //console.log('DEBUG PROPS', props);
        super(props);
        /*
        //console.log('DEBUG PROPS.PATH', props.path);
        let path = this.props.path;
        if (path && path.startsWith("/faculty")) {
            // to compute the backend path, we have first to remove the first part "/cattedreonline/corso"
            // from the path being shown in the frontend
            path = path.substring(0, 17);
        }

        //console.log('DEBUG MAPPING************', localStorage.getItem('persist:root'));
        const stateStr = localStorage.getItem('persist:root') || "";
        const objState = JSON.parse(stateStr);
        const app = JSON.parse(objState.app);
        let backendPath = props.path;
        //console.log('DEBUG state', app);
        if (app && app.mapping) {
            let mapping = new Map(Object.entries(app.mapping).map(([key, value]) => [key, String(value)]));

            //console.log('DEBUG mapping************', mapping);
            backendPath = computeBackendPath('/faculty', mapping);
            //console.log('DEBUG backendPath************', backendPath);
        }

        const pagePrefix = 'page/';
        const pagePath = `${pagePrefix ? pagePrefix : "/"}${this.props.language ? this.props.language : "it"}${backendPath.substring(pagePrefix ? pagePrefix.length : 1)}`;

        this.dataUrl = `${API_CONFIG.BASE_URL}/${pagePath}`;
        this.state={
            ...this.state,
            profData:{}
        }*/
    }

    async fetchData(url: string) {
        try {
            //console.log('DEBUG, url', url);
            this.setState({ isFetching: true });
            console.log("Loading contents from " + url);
            let data: any = {}
            // let response: any = {}
            // response = await axios.get(url);
            // data = response.data;

            // let stateUpdates: any = { isFetching: false };
            // if (response.status < 300) {
            //     console.log("Content from url " + url + " has been loaded");
            //     data = this.prefilterData(data);
            //     stateUpdates["data"] = data as Page;
            // } else {
            //     console.log("Cannot load data for at url " + url);
            //     console.log(response);
            // }

            const myUrl = new URL(window.location.toLocaleString());
            const professorId = myUrl.pathname.split('/')[2];
            const professorData = await axios.get(API_CONFIG.BASE_URL + '/professor/' + professorId + '/' + this.props.language);

            data.title = 'Professor' + ": " + professorData.data.name + ' | LUISS Guido Carli';
            if(professorData.data.bio) {
                data.subtitle = professorData.data.bio.replace(/(<([^>]+)>)/ig, '');
            } else {
                data.subtitle = professorData.data.bio;
            }
            data = this.prefilterData(data);
            //console.log('DEBUG, stateUpdates', stateUpdates);
            this.setState({ data: data as Page, isFetching: false, profData: professorData.data})

            return data;

        } catch (e) {

            console.warn("WARNING: Data retrieve failed for url " + url, e);

            if (this.mounted) {
                this.setState({ isFetching: false });
            }

            return null;
        }
    }

    prefilterData(data: any): Page {
        return {
            title: data.title,
            subtitle: data.subtitle,
            two_columns: false,
            desktop_navbar_color: "dark",
            mobile_navbar_color: "dark",
            image: "",
            video: "",
            internal_menu: [],
            left_column: [
            ],
            components: [{
                type: "faculty_profile",
                label: "Faculty profile component",
                data: 'https://4hoe6lrrzd.execute-api.eu-west-1.amazonaws.com/dev/component/faculty_profile/it/897eb965-6092-4d78-8597-7e25073368ba',
                dataObj: null
            }],
            path: this.props.path,
            langcode: this.props.language
        }
    }

    componentWillUnmount(): void {
        this.mounted = false;
    }

    onDataLoaded(data: Page) {
        super.onDataLoaded(data);
    }

    render() {

        let data: Page = this.state.data;

        let aosAnimation = {};
        let rightColumn = { span: 12, offset: 0 };

        if (data) {

            if (this.state.placeholder) {
                aosAnimation = {
                    "data-aos": "fade-up",
                    "data-aos-offset": 2,
                    "data-aos-id": "components-list",
                    "data-aos-anchor": "#root",
                    "data-aos-anchor-placement": "top-top",
                    "data-aos-duration": 1000
                }
            }

            // if we are in a two columns layout on desktop, the right column will be large 7/12 of the page
            if (data.two_columns && !extraSmallLayout()) {
                rightColumn = { span: 7, offset: 0 /*, offset: 5*/ };
            }
        }

        if (this.state.notFound || ((!data || !data.desktop_navbar_color || (data.langcode && data.langcode !== "und" && data.langcode !== this.props.language)) && !this.state.isFetching)) {
            // if the fetching has completed but there is no data we return the 404 page

            // if the page has not been translated (and the url is the one with the page id),
            // the page in the other language is returned and its language property mismatch
            // otherwise no page is returned and notFound is true
            return (
                <NotFoundComponent type={this.state.notFound ? "PAGE" : "TRANSLATION"}
                    language={this.props.language} changeLanguage={this.props.changeLanguage} />
            );
        }

        let LeftContent = this.props.leftContentClass;
        return (
            <div id="page"
                className={`${this.props.logoAnimationCompleted ? "" : "logo-animation"} ${extraSmallLayout() ? "mobile" : "desktop"}`}>
                <Container fluid={true} id="page-container"
                    className={`${this.microformatsPageType} ${this.state.placeholder ? "show-placeholder" : "show-contents"}`}>
                    {
                        // after we have loaded the page data, we can render the contents
                        (data) &&
                        <>
                            <Helmet defaultTitle="Luiss Guido Carli">
                                <title>{data.title + " | Luiss"}</title>
                                <meta property="og:title" content={data.title + " | Luiss"} />
                                <meta name="twitter:title" property="twitter:title" content={data.title} />

                                {data.subtitle &&
                                    <meta name="description" property="description" content={data.subtitle} />}
                                {data.subtitle && <meta property="og:description" content={data.subtitle} />}
                                {data.subtitle && <meta name="twitter:description" property="twitter:description"
                                    content={data.subtitle} />}

                                <meta property="og:image"
                                    content={data.image ? data.image : HIGH_LEVEL_CONFIG.DEFAULT_IMAGE_URL} />
                                <meta name="twitter:image" property="twitter:image"
                                    content={data.image ? data.image : HIGH_LEVEL_CONFIG.DEFAULT_IMAGE_URL} />
                                <meta name="twitter:image:alt" property="twitter:image:alt" content={data.title} />

                                {data.video && <meta name="og:video" property="og:video" content={data.video} />}

                                <meta property="og:type" content={this.ogPageType} />

                                <meta property="og:url" content={"https://www.luiss.it" + this.props.path} />
                            </Helmet>

                            {data.two_columns && this.props.url?.includes("/course/") && this.props.path !== "/" &&
                                <Row>
                                    <TemplateCoursePagePlaceholder className={extraSmallLayout() ? "marginFixer buttonFix" : "buttonFix"} image={data.image} video={data.video} />
                                </Row>
                            }
                            <Row className="contents-row e-content">
                                {
                                    // two columns layout - desktop - the fixed left column
                                    !extraSmallLayout() && data.two_columns && this.props.path !== "/" &&
                                    <Col sm={5} xs={0} className="left-column fixed-left-column">
                                        <LeftContent page={data} language={this.props.language}
                                            layoutColumns={(!extraSmallLayout() && data.two_columns) ? 2 : 1} />
                                    </Col>
                                }
                                <Col sm={rightColumn}>
                                    {
                                        // two columns layout - desktop - the image placeholder shown at the beginning
                                        !extraSmallLayout() && data.two_columns && this.props.path !== "/" && !this.props.url?.includes("/course/") &&
                                        <TemplatePagePlaceholder className={"disappearing"}
                                            image={data.image} video={data.video} />
                                    }
                                    {
                                        // one column layout - desktop - the left contents with the placeholder on the right
                                        !extraSmallLayout() && !data.two_columns && this.props.path !== "/" && !this.props.url?.includes("/summer_course/") &&
                                        <Container fluid={true} className="one-column-title-container">
                                            <Row>
                                                <Col sm={5} xs={0} className="left-column">
                                                    &nbsp;
                                                </Col>
                                                <Col xs={12} sm={7}>
                                                    <TemplatePagePlaceholder image={data.image} video={data.video} />
                                                </Col>
                                            </Row>
                                        </Container>
                                    }
                                    {
                                        // mobile - we show the mobile version of the left content (always in one column)
                                        extraSmallLayout() && !this.props.url?.includes("/summer_course/")  && !this.props.url?.includes("/faculty/")   && this.props.path !== "/" &&
                                        <LeftContent page={data} language={this.props.language}
                                            layoutColumns={(!extraSmallLayout() && data.two_columns) ? 2 : 1} />
                                    }
                                    <div id="components-list" {...aosAnimation}>
                                        {
                                            this.beforeRightComponentsList(data)
                                        }
                                        {
                                            data.components.map((c: ComponentId, index: number) => {

                                                //console.log('*****DEBUG in components map')
                                                try {
                                                    let CTemplateComponent = COMPONENTS.get(c.type);

                                                    if (!CTemplateComponent) return null;

                                                    let idProps = {};
                                                    let dataProps = {};

                                                    if (data.internal_menu && data.internal_menu.length) {
                                                        if (index < data.internal_menu.length) {
                                                            idProps = {
                                                                id: this.sectionId(data.internal_menu[index])
                                                            };
                                                        }
                                                    }

                                                    if (index === data.components.length - 1) {
                                                        idProps = {
                                                            id: LAST_COMPONENT_ID
                                                        };
                                                    }

                                                    if (!c.data) {
                                                        dataProps = { data: { empty: true } };
                                                    }

                                                    if (c.dataObj) {
                                                        dataProps = { data: c.dataObj };
                                                    }

                                                    return (
                                                        <ErrorBoundary key={"boundary-" + index}>
                                                            <C100ProfileCard {...idProps} key={"component-" + index}
                                                                data={this.state.profData}
                                                                query={this.props.query}
                                                                path={this.props.path}
                                                                navigate={this.props.navigate}
                                                                language={this.props.language}
                                                                url={c.data}
                                                                data-aos="fade-up" {...dataProps}
                                                                layoutColumns={(!extraSmallLayout() && data.two_columns) ? 2 : 1} />
                                                        </ErrorBoundary>
                                                    );

                                                } catch (e) {
                                                    console.warn("WARNING: Uncaught exception in component " + c.type, e);
                                                    return null;

                                                }
                                            })
                                        }

                                    </div>
                                    {
                                        this.props.path === "/" && <div className='bottom-background' />
                                    }
                                </Col>
                            </Row>
                            <TemplatePageFooter
                                linksKeys={[...HOME_PAGE_FOOTER_LINKS, ...SUBPAGE_FOOTER_ADDITIONAL_LINKS]} />
                        </>
                    }
                </Container>
            </div>
        );
    }
}

export default FacultyProfilePage;